export default __webpack_public_path__ + "static/carousel-15-b7efecdaac59d736c839f0e9cce4efad.jpg";